import { AcceptanceStatus } from "projects/common/src/public-api";
import { AddressComponents } from "../../../../common/src/lib/models/address-comments.model";
import { TimeRange } from "../../../../common/src/lib/models/time-range.model";

export interface AssessmentTimeRange {
    id: number;
    assessmentId: number;
    startTime: Date;
    endTime: Date;
}

export type AssessmentStatus = 'submitted' | 'canceled';

export interface Assessment {
    docType: 'Assessment';
    id: number;
    createdAt: Date;
    address: AddressComponents;
    unit: string | null;
    assigneeId: number | null;
    assigneeFirstName: string | null;
    assigneeLastName: string | null;
    businessName: string | null;
    clientId: number;
    email: string | null;
    firstName: string;
    lastName: string;
    jobType: string;
    ownerId: number;
    ownerFirstName: string;
    ownerLastName: string;
    clientCreatedAt: Date;
    salesTaxPercentage: number;
    phoneNumber: string;
    extNumber: string | null;
    type: 'personal' | 'business';
    ranges: TimeRange[];
    status: AssessmentStatus;
    workflowId: number;
    denied: boolean;
    emailOpened: boolean;
    invoiceId?: number | null;
    estimateId?: number | null;
    jobId?: number | null;
}

export interface AssessmentTileData {
    docType: 'Assessment';
    id: number;
    createdAt: Date;
    firstName: string;
    lastName: string;
    businessName: string | null;
    assigneeId: number | null;
    assigneeFirstName: string | null;
    assigneeLastName: string | null;
    ownerId: number;
    ownerFirstName: string;
    ownerLastName: string;
    startTime: Date;
    endTime: Date;
    jobType: string;
    phoneNumber: string;
    acceptanceStatus: AcceptanceStatus;
    rangeId: number;
    workflowId: number;
    status: 'submitted' | 'canceled';
    clientId: number;
    clientCreatedAt: Date;
    salesTaxPercentage: number;
    invoiceId?: number | null;
    estimateId?: number | null;
    jobId?: number | null;
}

export function assessmentTileData(from: Assessment, rangeId: number): AssessmentTileData {
    const range = from.ranges.find(r => (r as any).rangeId === rangeId)!;
    return {
        docType: 'Assessment',
        id: from.id,
        createdAt: from.createdAt,
        assigneeId: from.assigneeId,
        ownerId: from.ownerId,
        ownerFirstName: from.ownerFirstName,
        ownerLastName: from.ownerLastName,
        assigneeFirstName: from.assigneeFirstName,
        assigneeLastName: from.assigneeLastName,
        businessName: from.businessName,
        firstName: from.firstName,
        lastName: from.lastName,
        jobType: from.jobType,
        phoneNumber: from.phoneNumber,
        startTime: range.startTime,
        endTime: range.endTime,
        acceptanceStatus: assessmentAcceptanceStatus(from),
        rangeId,
        workflowId: from.workflowId,
        status: from.status,
        clientId: from.clientId,
        clientCreatedAt: from.clientCreatedAt,
        salesTaxPercentage: from.salesTaxPercentage,
        invoiceId: from.invoiceId,
        estimateId: from.estimateId,
        jobId: from.jobId,
    };
}

export function assessmentAcceptanceStatus(assessment: Assessment): AcceptanceStatus {
    if(assessment.assigneeId === null)
        return 'accepted';
    if(assessment.denied)
        return 'denied';
    return 'pending';
}
